import { useCallback, useContext, useEffect } from 'react';

import { message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';

import { PropertyDataSection } from './components';
import {
  AdditionalDataSection,
  ClientDataSection,
  PaymentMethodSection,
  QuotationStepButtons,
  ValiditySection,
} from '../../../../../shared';

import QuotationService from '../../../../../../../../../shared/services/quotation';

import { AuthContext } from '../../../../../../../../../shared/contexts';
import {
  GenericDataFormContext,
  QuotationInfoContext,
  StepOneFormContext,
} from '../../../../../shared/contexts';
import { StepFourFormContext } from '../../contexts';

import { displayErrorMessage, formattedDateVigency, getUserInfo } from '../../../../../../../../../shared/utils';

import {
  InsertInsuredPolicyholder,
  InsertRiskLocationRequest,
  SendPaymentMethodRequest,
  SendProposalRequest,
  Base,
} from '../../../../../../../../../shared/interfaces';
import { QuotationStep } from '../../../../../shared/interfaces';
import { BranchDocumentsURL, BudgetType } from '../../../../../utils/quotation-documents.enum';
import { QuotationContextData } from '../../../../../../../../../shared/interfaces/services/quote-pdf-service';
import { getQuoteDocumentBase64, transformToPdfQuote } from '../../../../../utils';
import EmailService, { buildSendMailRequest } from '../../../../../../../../../shared/services/email';
import { ContentTypeValue, MESSAGES_SENDMAIL } from '../../../../../../../../../shared/interfaces/services/email-services';
import { StepTwoFormContext } from '../../../StepTwo/contexts';
import { StepThreeFormContext } from '../../../StepThree/contexts';
import { CompanyData } from '../../../../../../../../../shared/interfaces/services/company-data-enum';
import { TransferRightsRequest } from '../../../../../../../../../shared/interfaces/services/transfer-rights-service';
import { PERSON_TYPE } from '../../../../../../../../../shared/interfaces/enums';

export const FormIssue = () => {
  const {
    errorCreditCardMessage,
    listCreditCardInsured,
    methodSelectedFromStepThree,
    paymentMethodFormValues,
    validitySectionForm,
    propertyDataForm,
    setAdditionalDataFormValues,
    setErrorCreditCardMessage,
    setPaymentMethodFormValues,
    setMethodSelectedFromStepThree,
    transferRightsList,
  } = useContext(StepFourFormContext);

  const {
    paymentMethodSectionForm,
    setCanShowSpinner,
    clientDataSectionForm,
    setclientDataFormValues,
    additionalDataSectionForm,
    provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan, paymentMethodsList,
  } = useContext(GenericDataFormContext);
  const {
    personalEffectsQuotationComponents,
    personalEffectsPaymentMethodsForm,
    quotationResponse
  } = useContext(StepThreeFormContext);
  const { stepOneForm, clientSelected } = useContext(StepOneFormContext);
  const {
    setCanShowConfirmIssue,
    quotationInfo,
    setCurrentStep,
    setQuotationInfo,
  } = useContext(QuotationInfoContext);
  const { stepTwoForm, activeKey, planOptionsBySelectedPlan } = useContext(StepTwoFormContext);
  const authContext = useContext(AuthContext);
  const [canShowError] = useForm();
  const dateExpiredCreditCard = dayjs(paymentMethodFormValues?.expiration);

  const paymentMethodExpirationMonth = dateExpiredCreditCard?.month() + 1;
  const paymentMethodExpirationYear = dateExpiredCreditCard?.year();

  const numberCreditCard = String(paymentMethodFormValues?.cardNumber);

  const creditCardFiltered = listCreditCardInsured?.tarjetasDelAsegurado.find(
    (tarjeta: { numeroTarjeta: string }) =>
      tarjeta.numeroTarjeta === numberCreditCard
  );

  const codeMethodPayment = methodSelectedFromStepThree?.codigoFormaDePago;

  const insertRiskLocation = async () => {
    personalEffectsQuotationComponents.map(async (quotationComponent) => {
      const address = propertyDataForm.getFieldValue(
        `propertyDataAddress${quotationComponent.nroComponente}`
      );

      const params: InsertRiskLocationRequest = {
        numeroCotizacion: Number(quotationInfo!.token),
        rama: Number(quotationInfo?.branch),
        arse: Number(quotationInfo?.arse),
        componente: quotationComponent.nroComponente,
        direccion: address,
        numeroDomicilio: 0,
        inspeccion: {
          nombreContacto: clientSelected?.nombre ?? '',
          telefono: '',
          email: '',
          horaDesde: '',
          horaHasta: '',
          comentarios: '',
        },
      };

      try {
        await QuotationService.postInsertRiskLocation(params);
      } catch (error: any) {
        setErrorCreditCardMessage(error.message);
      }
    });
  };

  const sendClientData = useCallback(async () => {
    const {
      fullName,
      societyType,
      genderType,
      perceptionAgent,
      ivaCondition,
      address,
      documentNumber,
      documentType,
      cuit,
      nationality,
      inscriptionDate,
      inscriptionNumber,
      contractDate,
    } = clientDataSectionForm.getFieldsValue();

    const { cbuNumber, cardNumber, companyCreditCard } =
      paymentMethodSectionForm.getFieldsValue();

    const {
      profession,
      civilStatus,
      economicActivity,
      addressEmail,
      rutaNumber,
      cuilNumber,
      telephoneNumber,
      telephoneNumberJob,
      cellphoneNumber,
      webPage,
      birthDate,
      placeOfBirth,
      countryBirth,
    } = additionalDataSectionForm.getFieldsValue();

    const params: InsertInsuredPolicyholder = {
      numeroCotizacion: Number(quotationInfo!.token),
      codigoAsegurado: Number(clientSelected?.nroAsegurado),
      nombreApellido: fullName,
      tipoDeSociedad: societyType,
      profesion: profession,
      genero: genderType,
      estadoCivil: civilStatus,
      actividadEconomica: economicActivity,
      mail: addressEmail,
      agenteDePercepcion: perceptionAgent,
      cbuDePago: cbuNumber,
      cbuParaSiniestros: cbuNumber,
      nroDeRuta: rutaNumber,
      inscripcionIva: ivaCondition,
      domicilio: {
        calleYNro: address,
        codigoPostal: Number(clientSelected?.codigoPostal),
        sufijoPostal: Number(clientSelected?.sufijoCodigoPostal),
      },
      documento: {
        tipoDocumento: documentType,
        numeroDocumento: documentNumber,
        cuit: cuit,
        cuil: cuilNumber,
      },
      telefonos: {
        particular: telephoneNumber,
        laboral: telephoneNumberJob,
        celular: cellphoneNumber,
        paginaWeb: webPage,
      },
      nacimiento: {
        fecha: birthDate ? dayjs(birthDate).format('DD-MM-YYYY') : "01-01-1999",
        lugar: placeOfBirth || '',
        codigoPais: countryBirth || 0,
        codigoNacionalidad: nationality || 0,
      },
      inscripcion: {
        fecha: dayjs(inscriptionDate).format('DD-MM-YYYY'),
        numero: inscriptionNumber,
        fechaDeContrato: dayjs(contractDate).format('DD-MM-YYYY'),
      },
    };

    if (cardNumber) {
      params.tarjetaDeCredito = {
        idEmpresa: companyCreditCard,
        numero: cardNumber,
        anioFin: paymentMethodExpirationYear,
        mesFin: paymentMethodExpirationMonth,
      };
    }

    try {
      await QuotationService.postInsertInsuredPolicyholder(params);
    } catch (error: any) {
      setErrorCreditCardMessage(error.message);
    }
  }, [
    clientDataSectionForm,
    additionalDataSectionForm,
    paymentMethodSectionForm,
    setErrorCreditCardMessage,
    quotationInfo,
  ]);

  const sendProposal = useCallback(async () => {
    const userName =
      authContext?.getUserInfo()?.intermediarioPrincipal?.nombreInter;

    const { startDate, endDate } = formattedDateVigency(
      validitySectionForm.getFieldValue('validityDate')
    );

    const params: SendProposalRequest = {
      numeroCotizacion: Number(quotationInfo!.token),
      fechaDesde: startDate,
      fechaHasta: endDate,
      usuario: userName,
    };

    try {
      const response = await QuotationService.postSendProposal(params);

      setQuotationInfo((prev) => ({
        ...prev!,
        proposalNumber: response.data.numeroDePropuesta,
      }));
      await invokeSendEmail();
      setCanShowConfirmIssue(true);
    } catch (error) { }
  }, [quotationInfo]);

  const sendPaymentMethod = useCallback(async () => {
    const { cbuNumber, cardNumber, companyCreditCard } =
      paymentMethodSectionForm.getFieldsValue();

    const creditCard = {
      idEmpresa: companyCreditCard ?? 0,
      numero: cardNumber || 0,
      anioFin: creditCardFiltered?.anioHasta ?? paymentMethodExpirationYear,
      mesFin: creditCardFiltered?.mesHasta ?? paymentMethodExpirationMonth,
    };

    const params: SendPaymentMethodRequest = {
      numeroCotizacion: Number(quotationInfo!.token),
      codigoFormaDePago: codeMethodPayment,
      numeroCbu: cbuNumber || 0,
      tarjetaDeCredito: creditCard,
    };

    try {
      await QuotationService.postInsertPaymentData(params);
    } catch (error: any) {
      paymentMethodSectionForm.setFields([{ name: 'cbuNumber', errors: [error.message] }]);
      throw error;
    }
  }, [
    paymentMethodSectionForm,
    creditCardFiltered,
    paymentMethodExpirationYear,
    codeMethodPayment,
    quotationInfo,
  ]);

  const sendTransferRights = useCallback(async () => {
    if (!transferRightsList || transferRightsList.length === 0) return;

    try {
      for (let index = 0; index < transferRightsList.length; index++) {
        const transferData = transferRightsList[index];

        const personTypeInfo = transferData.tipoPersona === PERSON_TYPE.FISICA.codigo
          ? PERSON_TYPE.FISICA
          : PERSON_TYPE.JURIDICA;
        const tipoDePersona = personTypeInfo.valor;

        const nombreApellido = transferData.tipoPersona === PERSON_TYPE.FISICA.codigo
          ? `${transferData.nombre} ${transferData.apellido}`
          : transferData.denominacion || '';
        const userInfo = getUserInfo();
        const base: Base = {
          nit1: userInfo.nit1!,
          nivc: userInfo.nivc!,
          sucursal: userInfo.sucursal,
          empresa: userInfo.empresa,
          niv1: userInfo.niv1!,
          nivt: userInfo.nivt!,
        };
        const transferRequest: TransferRightsRequest = {
          numeroCotizacion: Number(quotationInfo!.token),
          base: base,
          rama: Number(quotationInfo?.branch),
          arse: 1,
          componente: personalEffectsQuotationComponents[0]?.nroComponente || 1,
          riesgo: transferData.riesgo,
          cobertura: Number(transferData.cobertura),
          secuencia: index + 1,
          nombreApellido,
          tipoDePersona,
          numeroDocumento: Number(transferData.dni || 0),
          cuit: transferData.cuit ? Number(transferData.cuit) : undefined,
        };
        await QuotationService.postInsertTransferRights(transferRequest);
      }
    } catch (error) {
      throw error;
    }
  }, [transferRightsList, quotationInfo, personalEffectsQuotationComponents]);

  interface ValidationError {
    errorFields: Array<{
      name: string[];
      errors: string[];
      warnings: string[];
    }>;
  }

  const isValidationError = (error: any): error is ValidationError => {
    return error && Array.isArray(error.errorFields);
  };

  const getErrorMessage = (errorNameField: string) => {
    const lastCharacter = errorNameField.slice(-1);
    const coverageInfo = personalEffectsQuotationComponents.find(
      (quotationComponent) =>
        quotationComponent.nroComponente.toString() === lastCharacter
    );
    const errorMessage = `Se encontraron errores en Efectos Personales ${coverageInfo?.nroComponente}`;

    return errorMessage;
  };

  const validatePropertyDataSection = async () => {
    try {
      await propertyDataForm.validateFields();
    } catch (error) {
      if (isValidationError(error)) {
        const errorFields = error.errorFields;

        if (errorFields.length === 1) {
          canShowError.setFieldValue('isError', false);

          const errorMessage = getErrorMessage(errorFields[0].name[0]);
          message.error(errorMessage);
        }
      }

      throw new Error('Error en Datos del cliente');
    }
  };

  const handlerOnClick = useCallback(async () => {
    setCanShowSpinner(true);
    try {
      await Promise.all([
        clientDataSectionForm.validateFields(),
        paymentMethodSectionForm.validateFields(),
        propertyDataForm.validateFields(),
      ]);

      await validatePropertyDataSection();

      setclientDataFormValues(clientDataSectionForm.getFieldsValue());
      setPaymentMethodFormValues(paymentMethodSectionForm.getFieldsValue());

      await Promise.all([
        insertRiskLocation(),
        sendClientData(),
        sendPaymentMethod(),
      ]);
      await sendTransferRights();
      await sendProposal();
    } catch (error) {
      message.error('Debe completar todos los campos');
    } finally {
      setCanShowSpinner(false);
    }
  }, [
    additionalDataSectionForm,
    clientDataSectionForm,
    paymentMethodSectionForm,
    sendClientData,
    sendPaymentMethod,
    sendProposal,
    sendTransferRights,
    setAdditionalDataFormValues,
    setclientDataFormValues,
    setCanShowSpinner,
    setPaymentMethodFormValues,
    transferRightsList,
  ]);

  const handlerBackButtonOnClick = useCallback(() => {
    setclientDataFormValues(clientDataSectionForm.getFieldsValue());
    setAdditionalDataFormValues(additionalDataSectionForm.getFieldsValue());
    setPaymentMethodFormValues(paymentMethodSectionForm.getFieldsValue());
    setCurrentStep(QuotationStep.THREE);
  }, [
    additionalDataSectionForm,
    clientDataSectionForm,
    paymentMethodSectionForm,
    setAdditionalDataFormValues,
    setclientDataFormValues,
    setCurrentStep,
    setPaymentMethodFormValues,
  ]);

  useEffect(() => {
    if (errorCreditCardMessage) {
      message.error(errorCreditCardMessage);
      setErrorCreditCardMessage('');
    }
  }, [errorCreditCardMessage]);

  const invokeSendEmail = async () => {

    const ctx: QuotationContextData = {
      stepOneForm,
      clientSelected,
      stepTwoForm, activeKey,
      quotationResponse, planOptionsBySelectedPlan, paymentMethodsList,
      provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan,
      quotationInfo, personalEffectsPaymentMethodsForm,
      branchDocumentsURL: BranchDocumentsURL.EFECTOS_PERSONALES
    };
    try {
      const distributionListKey = "PROPUESTA_" + String(ctx.quotationInfo?.article).padStart(6, '0');
      const result = await getQuoteDocumentBase64(transformToPdfQuote(ctx, BudgetType.PRODUCTOR), BranchDocumentsURL.EFECTOS_PERSONALES);
      if (result) {
        const payload = await buildSendMailRequest({
          subject: `Cotización ${ctx.quotationInfo?.token} - ${CompanyData.COMPANY_NAME}`,
          body: 'Copia del Productor',
          includeAttachments: true,
          attachmentBase64: result.base64,
          attachmentName: result.fileName,
          attachmentMimeType: ContentTypeValue.PDF,
          saveToSentItems: true,
        }, distributionListKey);

        if (payload) await EmailService.sendMailViaLambda(payload);
      }
    } catch (error) {
      displayErrorMessage(MESSAGES_SENDMAIL.ERROR_MESSAGE);
    }
  }

  return (
    <>
      <ValiditySection validitySectionForm={validitySectionForm} />

      <ClientDataSection />

      <AdditionalDataSection />

      <PaymentMethodSection
        paymentMethodsForm={personalEffectsPaymentMethodsForm}
        setMethodSelectedFromStepThree={setMethodSelectedFromStepThree}
      />

      <PropertyDataSection />

      <QuotationStepButtons
        label='Enviar'
        onClick={handlerOnClick}
        onPressBackButton={handlerBackButtonOnClick}
      />
    </>
  );
};
